import { useEffect, useState } from "react";
import { CHAPTERS } from "../chapters";

/**
 * Tracks which Charge Journey chapter is most visible in the viewport.
 */
export default function useActiveChapter() {
  const [activeId, setActiveId] = useState(CHAPTERS[0].id);

  useEffect(() => {
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      return undefined;
    }

    const ratios = new Map();

    const pick = () => {
      let bestId = CHAPTERS[0].id;
      let best = 0;
      ratios.forEach((ratio, id) => {
        if (ratio > best) {
          best = ratio;
          bestId = id;
        }
      });
      // Near page top → force hero
      if ((window.scrollY || 0) < 80) {
        bestId = "hero";
      }
      setActiveId((prev) => (prev === bestId ? prev : bestId));
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("data-flash-chapter");
          if (!id) return;
          ratios.set(id, entry.isIntersecting ? entry.intersectionRatio : 0);
        });
        pick();
      },
      {
        // Bias toward the vertical center of the viewport
        root: null,
        rootMargin: "-28% 0px -38% 0px",
        threshold: [0, 0.15, 0.35, 0.55, 0.75, 1],
      }
    );

    const nodes = CHAPTERS.map((c) =>
      document.querySelector(`[data-flash-chapter="${c.id}"]`)
    ).filter(Boolean);

    nodes.forEach((node) => observer.observe(node));

    const onScroll = () => {
      if ((window.scrollY || 0) < 80) setActiveId("hero");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    pick();

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return activeId;
}
